import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {tap} from 'rxjs/operators';
import {MessagesService} from '../../shared/services/messages.service';
import {TrackingService} from '../../services/tracking.service';

declare const Stripe;

declare const Rewardful;

@Injectable({
  providedIn: 'root'
})
export class InstructorPlanService {

  constructor(
    private http: HttpClient,
    private messages: MessagesService,
    private tracking:TrackingService) {

  }

  updateInstructorPlan(
    activateTrial:boolean,
    instructorEmail:string,
    instructorPricingPlan: string,
    instructorPlanFrequency:string,
    stripeCouponId?:string,
    cancelReason?:string,
    cancelReasonValue?:string,
    cancelOtherReason?:string): Observable<any> {

    this.tracking.reportPlatformInitiateCheckout();

    const baseCallbackUrl = `${window.location.protocol}//${window.location.host}/admin/settings/school-settings/account`;

    let referralId = null;

    if (typeof Rewardful != "undefined") {
      referralId = Rewardful?.referral;
    }

    return this.http.post(environment.api.updateInstructorPlanUrl,
      {
        instructorEmail,
        instructorPricingPlan,
        instructorPlanFrequency,
        stripeCouponId,
        baseCallbackUrl,
        referralId,
        activateTrial,
        cancelReason,
        cancelReasonValue,
        cancelOtherReason
      });
  }

  createPurchaseLifetimeSessionAndRedirect(plan:string):Observable<any> {

    this.messages.info("Preparing checkout, please wait...");

    const baseCallbackUrl = `${window.location.protocol}//${window.location.host}/courses`;

    let referralId = null;

    if (typeof Rewardful != "undefined") {
      referralId = Rewardful?.referral;
    }

    return this.http.post(environment.api.purchaseInstructorLifetimePlanUrl,
      {
        baseCallbackUrl,
        referralId,
        plan
      })
      .pipe(
        tap(response => {

          const stripe = Stripe(response.stripePublicKey);

          stripe.redirectToCheckout({
            sessionId: response.sessionId
          });

          })
      );
  }

}
